import { sendMetric } from '@atheneum/api/dist/lib'

// AddToProcessing Metric
export enum AddToProcessingActionEnum {
  EXPERT_PAGE_EDIT = 'ExpertPageEdit',
  EXPERT_PAGE_ADD_TO_PROJECT = 'ExpertPageAddToProject',
  EXPERT_SEARCH_PIN = 'ExpertSearchPin',
  EXPERT_SEARCH_ADD_TO_PROJECT = 'ExpertSearchAddToProject',
  MANUAL_CREATE_USER = 'ManualCreateUser',
  AL_ADD_TO_PROJECT = 'ALAddToProject'
}

export enum AddToProcessingExpertTypeEnum {
  PDL = 'PDL',
  EXISTING_EXPERT = 'ExistingExpert',
  NON_EXISTING_EXPERT = 'NonExistingExpert'
}

export function sendAddToProcessingMetric(
  action: AddToProcessingActionEnum,
  expertType: AddToProcessingExpertTypeEnum
) {
  sendMetric('ExpertBulkCreate.AddToProcessing', undefined, {
    Action: action,
    ExpertType: expertType
  })
}

//FinishProcessing Metric
export enum FinishProcessingActionEnum {
  SUCCESS = 'Success',
  FAIL = 'Fail',
  DISCARD = 'Discard'
}

export function sendFinishProcessingMetric(action: FinishProcessingActionEnum) {
  sendMetric('ExpertBulkCreate.FinishProcessing', undefined, {
    Action: action
  })
}

//InitializeProcessing Metric
export enum InitializeProcessingActionEnum {
  EXPERT_PAGE_EDIT = 'ExpertPageEdit',
  EXPERT_PAGE_ADD_TO_PROJECT = 'ExpertPageAddToProject',
  EXPERT_SEARCH_PIN = 'ExpertSearchPin',
  EXPERT_SEARCH_ADD_TO_PROJECT = 'ExpertSearchAddToProject',
  MANUAL_CREATE_USER = 'ManualCreateUser',
  AL_ADD_TO_PROJECT = 'ALAddToProject'
}

export function sendInitializeProcessingMetric(
  action: InitializeProcessingActionEnum
) {
  sendMetric('ExpertBulkCreate.InitializeProcessing', undefined, {
    Action: action
  })
}
